<template>
    <div class="automation-item entry" :class="{'locked':!is('automations')}"
         @click="$emit('click', $event)">
        <div class="img-wrap">
            <img class="placeholder-img" v-if="!item.icon" src="@/assets/img/placeholder-img.svg">
            <img v-else :src="'data:image/png;base64,'+item.icon">
        </div>
        <div class="text" >
            <strong>{{ title }}</strong>
            <p>{{ item.action }} <b>{{ item.action_caption }}</b></p>
        </div>
        <div class="delete-icon" :class="{'locked':!is('automations')}"
             @click.stop="$emit('itemEntryDeleteClick', item)">
            <inline-svg :src="require('@/assets/img/delete_icon.svg')"/>
        </div>
    </div>
</template>

<script>

import {is} from "@/helpers/roles";

export default {
    props: ['item', 'title'],
	methods:{
    	is(role){
    		return is(role)
	    }
	}
}
</script>

<style scoped lang="scss">
.automation-item {
	.img-wrap {
		max-width: 70px;
		img {
			width: 30px;
		}
	}
	&.locked {
		pointer-events: none;
		opacity: 0.8;
	}
	.delete-icon.locked {
		pointer-events: none;
		opacity: 0.2;
	}
}
</style>
